import React, { useState } from "react";
import { getAssistantsCount } from "../Redux/Slice/Assistant/GetAssistantCountSlice";
import { useDispatch, useSelector } from "react-redux";
import { getPlanDetailsOfUser } from "../Redux/Slice/Plans/GetPlanDetailsOfUserSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { parseInteger } from "../Common/utils";

const useCreateAssistant = (customerId, setIsLoading) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { userPlanDetailsData } = useSelector((s) => s?.userPlanDetails);
  const [buyAdditionalAssistantModal, setBuyAdditionalAssistant] = useState({
    visible: false,
    type: "", // "BUY_ASSISTANT", "MAX_ASSISTANT_REACHED", "UPGRADE_PLAN"
    maxAssistant: 0,
    assistantAmount: 0,
  });

  const getAssistantCount = async () => {
    const result = await dispatch(getAssistantsCount());
    if (getAssistantsCount.fulfilled.match(result)) {
      return result?.payload || 0;
    }
    return 0;
  };

  const getPlanTypeDetails = async () => {
    const result = await dispatch(getPlanDetailsOfUser());
    if (getPlanDetailsOfUser.fulfilled.match(result)) {
      return result?.payload;
    }
    return userPlanDetailsData;
  };

  const navigateToCreateAssistant = () => {
    navigate(
      customerId
        ? `/add-assistant-builder/${customerId}`
        : "/add-assistant-builder",
      {
        state: {
          ...location?.state,
        },
      }
    );
  };

  const onClickCreateAssistant = async (isOnlyCheck = false) => {
    try {
      setIsLoading(true);
      const totalCreatedAssistantsCount = await getAssistantCount();
      const planTypeDetails = await getPlanTypeDetails();
      const isAllowedAdditionalAssistant =
        planTypeDetails?.isAdditionalAssistant || false;
      const totalAllowedAdditionalAssistant = parseInteger(
        planTypeDetails?.additionalAssistant
      );
      const totalAdditionalAssistantPurchased = parseInteger(
        planTypeDetails?.additionalAssistantPurchased
      );
      const assistantAmount = Number(planTypeDetails?.amount || 0);
      const totalAllowedAssistantOfCustomer =
        parseInteger(planTypeDetails?.noOfAssistants) +
        totalAdditionalAssistantPurchased;

      if (
        parseInteger(totalCreatedAssistantsCount) <
        totalAllowedAssistantOfCustomer
      ) {
        if (!isOnlyCheck) {
          navigateToCreateAssistant();
        }
        return true;
      } else if (
        isAllowedAdditionalAssistant &&
        totalAdditionalAssistantPurchased < totalAllowedAdditionalAssistant
      ) {
        setBuyAdditionalAssistant({
          visible: true,
          type: "BUY_ASSISTANT",
          maxAssistant:
            totalAllowedAdditionalAssistant - totalAdditionalAssistantPurchased,
          assistantAmount,
        });
      } else if (
        isAllowedAdditionalAssistant &&
        totalAdditionalAssistantPurchased >= totalAllowedAdditionalAssistant
      ) {
        setBuyAdditionalAssistant({
          visible: true,
          type: "MAX_ASSISTANT_REACHED",
          maxAssistant: 0,
          assistantAmount,
        });
      } else {
        setBuyAdditionalAssistant({
          visible: true,
          type: "UPGRADE_PLAN",
          maxAssistant: 0,
          assistantAmount,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
    return false;
  };

  const handleCloseBuyAdditionalAssistant = () => {
    setBuyAdditionalAssistant({
      visible: false,
      type: null,
      maxAssistant: 0,
      assistantAmount: 0,
    });
  };

  return {
    onClickCreateAssistant,
    buyAdditionalAssistantModal,
    handleCloseBuyAdditionalAssistant,
  };
};

export default useCreateAssistant;
